<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <position>
        </position> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import Position from './todo-position'
export default {
    components: {
        Position
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-positions/base-position.vue